import { ProductCategory, ProductListItemDTO } from '@iota/inh-core-v1-management-client';
import { SmartTableHeader } from '../components/smart-table/smart-table.component';
import { ProductCategoryDescriptions } from '../constants-and-enums/product-category';
import { getPropertyAsString } from '../utils';

export function categoryDescriptionFor(category?: ProductCategory): string {
    if (!category) {
        return '';
    }
    return ProductCategoryDescriptions.get(category) ?? category;
}

export function matchesProductFilter(product: ProductListItemDTO, normalizedFilterText: string): boolean {
    return [product.name, categoryDescriptionFor(product.productCategory), product.vendorName].some((value) =>
        (value ?? '').toLowerCase().includes(normalizedFilterText)
    );
}

export function filterProductsByText(products: ProductListItemDTO[], filterText: string): ProductListItemDTO[] {
    const normalizedFilterText = (filterText ?? '').toLowerCase();
    if (!normalizedFilterText) {
        return products;
    }

    return products.filter((product) => matchesProductFilter(product, normalizedFilterText));
}

/** Shared columns only; a caller adds its own leading column and hidden id. */
export const PRODUCT_TABLE_HEADERS = [
    { key: 'name', label: $localize`Name` },
    { key: 'category', label: $localize`Category` },
    { key: 'vendorName', label: $localize`Solution Partner` },
    { key: 'creationDate', label: $localize`Creation date` }
] as const satisfies readonly SmartTableHeader[];

export function productTableCells(product: ProductListItemDTO) {
    return {
        name: { data: product.name ?? '' },
        category: { data: categoryDescriptionFor(product.productCategory) },
        vendorName: { data: product.vendorName ?? '' },
        creationDate: { data: getPropertyAsString(product.creationDateTime), isDate: true }
    };
}
